module.exports = __webpack_public_path__ + "img/banner_improve.b4c82535.png";